import { Box, H5, Stack, Radio, Checkbox, Grid } from "@adfenix/alexandria";
import { ProgramService } from "@adfenix/types";
import { useFormContext } from "react-hook-form";
import { useDisabledFields } from "../useDisabledFields";
import { useTranslation } from "react-i18next";

export const ProgramPriceSettings = () => {
  const { t } = useTranslation();

  const disabledFields = useDisabledFields();

  const { register, setValue, watch } =
    useFormContext<ProgramService.ProgramModel>();
  const sortAscending = watch("sortProductAscending");

  return (
    <Stack spacing="l">
      <H5>{t("programBuilder.program.details.price.settings.label")}</H5>
      <Grid columns={["1fr", "1fr 1fr"]} gap="m">
        <Stack spacing="m">
          <Radio
            name="sortProductAscending"
            onChange={() =>
              setValue("sortProductAscending", true, { shouldDirty: true })
            }
            id="sortProductAscending"
            label={t("programBuilder.program.details.price.settings.order.asc")}
            checked={sortAscending}
            readOnly={disabledFields("sortProductAscending")}
          />

          <Radio
            name="sortProductAscending"
            onChange={() =>
              setValue("sortProductAscending", false, { shouldDirty: true })
            }
            id="sortProductDescending"
            label={t(
              "programBuilder.program.details.price.settings.order.desc"
            )}
            checked={!sortAscending}
            readOnly={disabledFields("sortProductAscending")}
          />
        </Stack>
        <Box>
          <Checkbox
            {...register("showPriceSummary")}
            label={t(
              "programBuilder.program.details.price.settings.checkbox.showSummary"
            )}
            readOnly={disabledFields("showPriceSummary")}
          />
        </Box>
      </Grid>
      <Box>
        <Checkbox
          {...register("allowSpecifyCostCenter")}
          label={t(
            "programBuilder.program.details.price.settings.checkbox.allowSpecifyCostCenter"
          )}
          readOnly={disabledFields("allowSpecifyCostCenter")}
        />
      </Box>
    </Stack>
  );
};
